var EHDI = EHDI || Object.create(null);

EHDI.loadScene = function setupLoader() {
    var localizable = EHDI.Assets.fetch("locale_" + EHDI.GAME.localeID);
    EHDI.localization.LocalizationXMLReader(localizable);
    
    var rotatePopUp = new EHDI.popup.RotatePopUp();
    
    EHDI.GAME.sceneManager.addNotification(rotatePopUp);
    
    
    EHDI.GAME.scaleManager.setResizeCallback(function() {
        EHDI.GAME.sceneManager.screenResize();
        if(!EHDI.BrowserInfo.isMobileDevice)
            return;
        if(EHDI.screen.viewWidth < EHDI.screen.viewHeight) {
            rotatePopUp.visible = true;
            if(EHDI.GAME.gameScene && EHDI.GAME.gameScene.pauseManager && !EHDI.GAME.gameScene.pauseManager.isEndGame) {
                EHDI.GAME.gameScene.pauseManager.pauseGame();
            } else if(EHDI.GAME.bgm)
                EHDI.GAME.soundManager.pauseBGM();
        } else {
            rotatePopUp.visible = false;
            if(EHDI.GAME.bgm)
                EHDI.GAME.soundManager.resumeBGM();
            else
                EHDI.GAME.bgm = EHDI.GAME.soundManager.playBGM("wabbit_ingame_bgm", 0.3);
        }
    })
    
    
    var loaderContainer = new PIXI.Container();
    //var shaglounge = new EHDI.aka.PixiText("hello world", {fontFamily: 'lakkireddy'});
    //loaderContainer.addChild(shaglounge);
    
    var dimbo = new EHDI.aka.PixiText("hello world", {fontFamily: 'dimboregular'});
    loaderContainer.addChild( dimbo );
    
    var nueva = new EHDI.aka.PixiText("hello world", {fontFamily: 'nuevastd-bold'});
    loaderContainer.addChild( nueva );
    
   /* window.addEventListener('screenDidAppear', function() {
        console.log("screen is now visible");
    });
    window.addEventListener('screenDidDisappear', destroy);*/
    //load config
    //initialize the json files to be managed
    EHDI.GAME.JSONManager = EHDI.JSONManager();

    function changeScene() {
        EHDI.GAME.sceneManager.changeScene(new EHDI.scene.TitleScene(), {alpha : {from : 0, to : 1}, duration : 0.5});
    }
    
    function update() {
        //console.log(EHDI.GAME.loader.getProgress());
        loadingBar.width = loadingWidth * EHDI.LoadManager.getProgress() / 100;
    };

    function startGame() {
        loadingBar.width = loadingWidth * EHDI.LoadManager.getProgress()  / 100;
        EHDI.GAME.updateManager.removeFrameListener(update);
        
        EHDI.GAME.dataManager = new EHDI.manager.DataManager();
        EHDI.GAME.achieveManager = new EHDI.manager.AchievementManager();
        
        logo.gotoAndPlay(0);
        if(EHDI.BrowserInfo.isIOS)
            logo.onComplete = showPlayButton;
        else
            logo.onComplete = changeScene;
    };
    
     var playButtonPressed = function() {
        EHDI.GAME.soundManager.playSFX("button_01");
        EHDI.GAME.sceneManager.changeScene(new EHDI.scene.TitleScene(), {x : {from : -EHDI.screen.stageWidth, to : 0}, duration : 0.5}, true);
    }
    
    function showPlayButton() {
        loadingContainer.visible = false;
        
        var play = new EHDI.displays.Button(EHDI.Assets.images["btn_play"], null, null, null);
        
        play.setOnClickFunction(playButtonPressed);
        
        play.position.set(0, EHDI.screen.stageHeight * 0.3);
        
        this.addChild(play);
    }

    var bg = new PIXI.Sprite(EHDI.displays.TextureRectangle(0x882f88, EHDI.screen.stageWidth, EHDI.screen.stageHeight));
    loaderContainer.addChild(bg);
    bg.anchor.set(0.5,0.5);
    
    var animationTextures = [];
    
    for(var i = 1; i <= 10; i++) {
        var number = '10';
        if(i < 10) {
            number = '0' + i;
        } animationTextures.push(EHDI.Assets.images['loader_animation00' + number]);
    }
    
    var logo = new PIXI.extras.AnimatedSprite(animationTextures);
    logo.loop = false;
    logo.animationSpeed = 0.1;
    
    logo.anchor.set(0.4175, 0.695);
    loaderContainer.addChild(logo);

    var loadingContainer = new EHDI.aka.Sprite(EHDI.Assets.images["bar_bg"]);
    loadingContainer.anchor.x = 0.5;
    loadingContainer.anchor.y = 0.5;
    loadingContainer.position.y = EHDI.screen.stageHeight * 0.25;
    loaderContainer.addChild(loadingContainer);

    var loadingBar = new PIXI.extras.TilingSprite(EHDI.Assets.images["bar_fill"], 489, 56);
    loadingContainer.addChild(loadingBar);
    loadingBar.x = -loadingContainer.width * 0.498;
    loadingBar.y = -loadingBar.height * 0.5;

    var loadingWidth = loadingBar.width;
    
    var loadingFrame = new EHDI.aka.Sprite(EHDI.Assets.images["frame"]);
    loadingFrame.anchor.set(0.5, 0.5);
    loadingContainer.addChild(loadingFrame);
    
    
    
    
    EHDI.LoadManager.queueAssets( AssetDirectory.load );
    EHDI.LoadManager.start(startGame);

    EHDI.GAME.updateManager.addFrameListener(update);
    
    function screenDidDisappear(){
      //destroy
      loadingContainer.destroy(true);
    }

    EHDI.GAME.sceneManager.changeScene(loaderContainer);
}
